// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/092c28876fda80d9b93c.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"8608739535b226ec1b9a","266":"d18116ae363f562969c7","267":"5f38447c5fcf0fc6f7b5"}[chunkId] + ".chunk.js";
};